; (function ($, window, document, undefined) {

    var name = 'customBadgeInput';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customBadgeInput.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            this.$menu = $(`<div class="dropdown-menu"></div`);
            this.$element.append(this.$menu);

            this.$input = $(`<li class="input">
                <span contenteditable placeholder="${this.options.placeholder}"></span>
            </li>`);
            this.$list.append(this.$input);
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$list = this.$element.find('ul');
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('keydown', 'span[contenteditable]', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    return;
                }
            });

            plugin.$element.on('keyup', 'span[contenteditable]', function (e) {
                plugin.searchItems($(this).html());
            });

            plugin.$element.on('focus', 'span[contenteditable]', function () {
                plugin.$menu.dropdown('show');
                plugin.populateItems();
            });

            plugin.$element.on('blur', 'span[contenteditable]', function () {
                plugin.$menu.dropdown('hide');
                plugin.resetSearch();
            });

            plugin.$element.on('mousedown', '.dropdown-item:not(.disabled)', function () {
                plugin.addSelectedItem({ [$(this).data('key')]: $(this).data('value') });
                plugin.resetSearch();
            });

            plugin.$element.on('click', 'span[data-event="remove"]', function () {
                plugin.removeSelectedItem($(this));
                plugin.resetSearch();
            });

            plugin.$element.on('shown.bs.dropdown', function () {
                plugin.resetSearch();
            });

            plugin.$list.on('click', function (e) {
                if (e.target != this) {
                    return;
                }

                plugin.$input.find('span[contenteditable]').focus();
            });
        },

        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        searchItems: function (keyword) {
            var items = { ...this.options.items };
            if (keyword = keyword.trim()) {
                items = Object.fromEntries(Object.entries(items).filter(([key, item]) => (this.options.showKeys && key.toLowerCase().includes(keyword.toLowerCase())) || item.toLowerCase().includes(keyword.toLowerCase())));
            }

            this.populateItems(items);

            return this;
        },

        resetSearch: function () {
            $.scrollTo(0, this.$menu);
            this.$input.find('span[contenteditable]').html('');
            this.populateItems();

            return this;
        },

        populateItems: function (items = { ...this.options.items }) {
            this.$menu.find('.dropdown-item').remove();

            if (Array.isArray(items)) {
                items = { ...items };
            }

            items = Object.keys(items).sort().reduce((object, key) => {
                object[key] = items[key];
                return object;
            }, {});

            if (Object.keys(items).length) {
                Object.keys(items).forEach(key => {
                    var node = $(`<a href="#" class="dropdown-item" data-key="${key}" data-value="${items[key]}">${items[key]}</a>`);
                    if (this.options.showKeys) {
                        node.prepend(`<span class="badge badge-primary mr-2">${key}</span>`);
                    }

                    this.$menu.append(node);
                });
            } else {
                var node = $(`<div class="dropdown-item disabled">No result can be found.</div>`);
                this.$menu.append(node);
            }

            return this;
        },

        addSelectedItem: function (item) {
            var key = Object.keys(item)[0];

            if (!this.options.items.hasOwnProperty(key)) {
                this.$element.trigger('error.inputBadge.item', [this, {
                    responseJSON: {
                        error: {
                            message: 'Selected item does not existed in the list.'
                        }
                    }
                }]);

                return;
            }

            if (this.options.maxItem > 0 && Object.keys(this.options.selectedItems).length >= this.options.maxItem) {
                if (this.options.maxItem == 1 && this.options.autoUpdate) {
                    this.val([item]);
                } else {
                    this.$element.trigger('error.inputBadge.item', [this, {
                        responseJSON: {
                            error: {
                                message: `Selected items has a maximum quantity of ${this.options.maxItem}.`
                            }
                        }
                    }]);
                }

                return;
            }

            var badge = $(`<li class="badge" data-key="${key}" data-value="${this.options.items[key]}">
                <span class="text">
                    ${this.options.showKeys ? `<span class="badge badge-primary mr-1">${key}</span>` : ``}
                    ${this.options.items[key]}
                </span>
                <span data-event="remove">
                    <i class="fas fa-times"></i>
                </span>
            </li>`);

            this.options.selectedItems = $.extend(item, this.options.selectedItems);
            delete this.options.items[key];

            this.$element.trigger('blur').trigger('selected.inputBadge.item', [this, item]);

            if (!this.$list.find('>.badge').length) {
                this.$list.prepend(badge);
                return;
            }

            this.$list.find('>.badge:last').after(badge);
        },

        removeSelectedItem: function (target) {
            var badge = target.closest('.badge'),
                key = badge.data('key'),
                value = badge.data('value'),
                item = { [key]: value };

            if (!this.options.selectedItems.hasOwnProperty(key)) {
                this.$element.trigger('error.inputBadge.item', [this, {
                    responseJSON: {
                        error: {
                            message: 'Selected item does not existed in the list.'
                        }
                    }
                }]);

                return;
            }

            this.options.items = $.extend(item, this.options.items);
            delete this.options.selectedItems[key];

            badge.remove();

            this.$element.trigger('removed.inputBadge.item', [this, item]);
        },

        setItems: function (items = {}) {
            this.options.items = { ...items };
            this.populateItems();

            return this;
        },

        val: function (items = null) {
            if (Array.isArray(items)) {
                items.forEach(item => {
                    if (!this.options.items.hasOwnProperty(item)) {
                        this.$element.trigger('error.inputBadge.item', [this, {
                            responseJSON: {
                                error: {
                                    message: 'Selected item does not existed in the list.'
                                }
                            }
                        }]);

                        return;
                    }
                });

                Object.keys(this.options.selectedItems).forEach(key => {
                    this.options.items[key] = this.options.selectedItems[key];
                    delete this.options.selectedItems[key];
                });

                this.$list.find('.badge').remove();
                items.forEach(item => {
                    this.addSelectedItem(item);
                });

                this.$element.trigger('reset.inputBadge.item', [this]);

                return this;
            }

            return { ...this.options.selectedItems };
        },
    });

    $.fn.customBadgeInput = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customBadgeInput.defaults = {
        autoUpdate: false,
        items: {},
        maxItem: 0,
        placeholder: '',
        selectedItems: {},
        showKeys: true,
    };
})(jQuery, window, document);
